(() => {
  const intro = document.querySelector('[data-memeify-intro]');
  if (!intro) return;

  const root = document.documentElement;
  const storageKey = 'memeifyIntroSeen';
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let alreadySeen = true;

  try {
    alreadySeen = window.sessionStorage.getItem(storageKey) === 'true';
  } catch (error) {
    intro.remove();
    return;
  }

  if (designMode || reducedMotion || alreadySeen) {
    intro.remove();
    return;
  }

  try {
    window.sessionStorage.setItem(storageKey, 'true');
  } catch (error) {
    intro.remove();
    return;
  }

  let finished = false;
  let exitTimer;
  let cleanupTimer;
  let safetyTimer;

  const finish = () => {
    if (finished) return;
    finished = true;

    window.clearTimeout(exitTimer);
    window.clearTimeout(safetyTimer);
    document.removeEventListener('keydown', handleKeydown);
    intro.setAttribute('aria-hidden', 'true');
    intro.classList.add('is-leaving');
    root.classList.remove('memeify-intro-active');

    cleanupTimer = window.setTimeout(() => {
      intro.remove();
    }, 450);
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') finish();
  };

  intro.hidden = false;
  intro.setAttribute('aria-hidden', 'false');
  root.classList.add('memeify-intro-active');

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      intro.classList.add('is-visible');
    });
  });

  intro.querySelector('[data-memeify-intro-skip]')?.addEventListener('click', finish, { once: true });
  document.addEventListener('keydown', handleKeydown);

  exitTimer = window.setTimeout(finish, 1750);
  safetyTimer = window.setTimeout(() => {
    window.clearTimeout(cleanupTimer);
    root.classList.remove('memeify-intro-active');
    intro.remove();
  }, 3500);
})();
